/** @format */

import $ from "jquery";
import axios from "axios";
import { Empty } from "antd";
import React, { useEffect, useRef, useState } from "react";

import Minimap from "../../../../../components/map/Minimap";
import { header } from "../../../../../components/api/Header";
import { getEnv } from "../../../../../lib/env";

function Page4({ date }) {
  const [sts, setSts] = useState([]);
  const [location, setLocation] = useState([
    41.03261314166325, 64.28638866665023,
  ]);
  const buttonRef = useRef();
  const [zoom, setZoom] = useState(6);
  const [selectedData, setSelectedData] = useState("");

  useEffect(() => {
    const fetchSts = async () => {
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/amudaryo/stations?date=${date}`,
          header()
        );
        setSts(res.data);
      } catch (err) {
        console.log("Ma'lumotlarni yuklashda xatolik yuz berdi.", err);
      }
    };

    fetchSts();
  }, [date]);

  const filterList = (text) => {
    $("#StsList li").each(function () {
      if ($(this)[0].innerText.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };

  const selectData = (s) => {
    setZoom(15);
    setLocation([s.lat, s.lan]);
    setSelectedData(s.id);
  };

  return (
    <div className='details-box'>
      <div className='details-box-left'>
        <div className='mb-2'>
          <input
            type='text'
            placeholder='Stansiya qidirish'
            className='form-control'
            onChange={(e) => filterList(e.target.value)}
          />
        </div>

        <ul style={{ maxHeight: "75vh", overflow: "auto" }} id='StsList'>
          {sts && sts.length > 0 ? (
            sts.map((s, i) => {
              return (
                <li
                  ref={buttonRef}
                  key={i}
                  className={s.lat && s.lan ? "haslatlng" : ""}
                  onClick={() => {
                    selectData(s);
                  }}>
                  <button
                    style={{
                      background: selectedData === s.id ? "#0b4aa9" : "",
                      color: selectedData === s.id ? "#fff" : "",
                    }}
                    className='sidebar-list'>
                    <table>
                      <tbody>
                        <tr>
                          <td>{s.nomi}</td>
                          <td>{s.data}</td>
                          <td
                            style={{
                              color: selectedData === s.id ? "#fff" : "#0b4aa9",
                            }}>
                            {s.birligi}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </button>
                </li>
              );
            })
          ) : (
            <Empty description="Ma'lumotlar mavjud emas" />
          )}
        </ul>
      </div>

      <div className='details-box-right'>
        <Minimap
          zoom={zoom}
          locations={sts}
          location={location}
          onSelectData={selectData}
        />
      </div>
    </div>
  );
}

export default Page4;
